import React from 'react';
import PropTypes from 'prop-types';
import Button from 'Common/Components/BlueButton/styled';
import useTheme from 'Hooks/UseTheme';

const BlueButton = ({
  onClick, label, disabled, className, isLoading, id, children, dataTestId
}) => {
  const { themeStyles } = useTheme();

  return (
    <Button id={ id } theme={ themeStyles } className={ className } onClick={ onClick } disabled={ disabled } type="button" isLoading={ isLoading } data-testid={ dataTestId || undefined }>{ label || children }</Button>
  );
};

BlueButton.defaultProps = {
  disabled: false,
  isLoading: false,
  className: '',
  id: '',
  dataTestId: ''
};

BlueButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  dataTestId: PropTypes.string
};

export default BlueButton;
